import Enum from "@/enums/Enum";
import BaseEnum from "@/enums/BaseEnum";
/**
 * 清掃状態
 */
export default class SeisoJotai extends BaseEnum{
    static YOI = {value: '0', name: '良い'} as Enum
    static HUTSU = {value: '1', name: '普通'} as Enum
    static WARUI = {value: '2', name: '悪い'} as Enum
    static HIJONI_WARUI = {value: '3', name: '非常に悪い'} as Enum
}
SeisoJotai.values = [SeisoJotai.YOI, SeisoJotai.HUTSU, SeisoJotai.WARUI, SeisoJotai.HIJONI_WARUI]
